import React from 'react'
import {
  Link
} from "react-router-dom";
import '../Pages/Header.css';
import '../Pages/Header_responsive.css';
import header_img from '../Images/logo.png';
export default function Header() {
  return (
    <>
      <header>
        <div class="container">
          <div class="row">
            <div class="col-md-4">
              <div class="header_logo">
                <Link to="/Firstpage">
                <img src={header_img} alt="The_Header_Logo"/>
                </Link>
                  
              </div>
            </div>
            <div class="col-md-8">
              <div class="links">
                <ul>
                  <li>
                    <Link to="/">Services</Link>
                    </li>
                  <li>
                    <Link to="/">Projects</Link>
                    </li>
                  <li>
                  <Link to="/">Portfolio</Link>
                  </li>
                  <li>
                  <Link to="/">Company</Link>
                  </li>
                </ul>
                <div class="button_adjust">
                  <button>CONTACT US</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  )
}
